import type { CSSProperties } from "react";
import { NumberField, SelectField } from "@/components/fields";
import { MONTHS_FULL } from "@/plan-logic/lib/dates";
import type { JobStart } from "@/plan-logic/questionnaire/jobStart";

const MONTH_OPTIONS: [number, string][] = [
  [0, "Not sure"],
  ...MONTHS_FULL.map((m, i): [number, string] => [i + 1, m]),
];

/**
 * "When did Ana start at Day job?" for a job with a defined benefit pension: the year and, if
 * known, the month (`questionnaire/jobStart.ts`). Optional: blank, Abi estimates it from the age.
 */
export function JobStartField({
  question,
  value,
  onChange,
  error,
  testId,
  style,
}: {
  question: string;
  value: JobStart;
  onChange: (v: JobStart) => void;
  error?: string;
  testId: string;
  style?: CSSProperties;
}) {
  return (
    <div style={style} data-testid={testId}>
      <div className="two">
        <NumberField
          label={question}
          value={value.year}
          onChange={(year) => onChange({ ...value, year })}
          placeholder="Year, e.g. 2012"
          error={error}
          testId={`${testId}-year`}
          style={{ margin: 0 }}
        />
        <SelectField
          label="Month (optional)"
          value={value.month ?? 0}
          options={MONTH_OPTIONS}
          onChange={(month) => onChange({ ...value, month: month || undefined })}
          testId={`${testId}-month`}
          style={{ margin: 0 }}
        />
      </div>
      <p className="hint">
        A defined benefit pension grows with your years there. Your pension statement shows the
        date. Not sure? Leave it blank and Abi estimates it from your age.
      </p>
    </div>
  );
}
